/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Give_Up_This_ChanceInputs */

const en_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give Up This Only Chance`)
};

const ar_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استسلم لهذه الفرصة الوحيدة`)
};

const de_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese einzige Chance aufgeben`)
};

const es_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renunciar a esta oportunidad`)
};

const fr_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renoncez à cette offre exclusive`)
};

const it_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiuta questa unica possibilità`)
};

const ja_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチャンスをあきらめる`)
};

const ko_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단 한 번의 기회를 놓치지 마세요`)
};

const pt_br_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desistir desta chance única`)
};

const ru_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказаться от возможности`)
};

const th_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้มเลิกโอกาสนี้ที่มีแค่ครั้งเดียว`)
};

const tr_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek Seferlik Şanstan Vazgeç`)
};

const zh_cn_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放弃仅有 1 次的机会`)
};

const zh_tw_give_up_this_chance = /** @type {(inputs: Give_Up_This_ChanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放棄僅有 1 次的機會`)
};

/**
* | output |
* | --- |
* | "Give Up This Only Chance" |
*
* @param {Give_Up_This_ChanceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const give_up_this_chance = /** @type {((inputs?: Give_Up_This_ChanceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Give_Up_This_ChanceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_give_up_this_chance(inputs)
	if (locale === "ar") return ar_give_up_this_chance(inputs)
	if (locale === "de") return de_give_up_this_chance(inputs)
	if (locale === "es") return es_give_up_this_chance(inputs)
	if (locale === "fr") return fr_give_up_this_chance(inputs)
	if (locale === "it") return it_give_up_this_chance(inputs)
	if (locale === "ja") return ja_give_up_this_chance(inputs)
	if (locale === "ko") return ko_give_up_this_chance(inputs)
	if (locale === "pt_br") return pt_br_give_up_this_chance(inputs)
	if (locale === "ru") return ru_give_up_this_chance(inputs)
	if (locale === "th") return th_give_up_this_chance(inputs)
	if (locale === "tr") return tr_give_up_this_chance(inputs)
	if (locale === "zh_cn") return zh_cn_give_up_this_chance(inputs)
	return zh_tw_give_up_this_chance(inputs)
});